import type { TRPCClientErrorLike } from "@trpc/client";

import type { AppRouter } from "../server/routers/_app";

export {
  httpBatchLink,
  httpLink,
  httpSubscriptionLink,
  loggerLink,
  splitLink,
  wsLink,
} from "@trpc/client";

export { superjson } from "../transformers/superjson";
export * from "./trpc";

export type TRPCClientErrorRouter = TRPCClientErrorLike<AppRouter>;

export type { UseTRPCMutationOptions } from "@trpc/react-query/shared";

export type { ArchiveType, Sex, TestType } from "@blis/prisma";
